import { useEffect } from "react";
import { useSite } from "@/context/SiteContext";
import { fill } from "@/lib/api";

const setMeta = (attr, key, value) => {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", value);
};

export const useSeo = (page, vars = {}) => {
  const { content } = useSite();
  const seo = content.seo;
  const title = fill(seo[`${page}_title`], vars) || seo.home_title;
  const desc = fill(seo[`${page}_desc`], vars) || seo.home_desc;
  useEffect(() => {
    document.title = title;
    setMeta("name", "description", desc);
    setMeta("property", "og:title", title);
    setMeta("property", "og:description", desc);
  }, [title, desc]);
};
